export enum ExpirationDateType {
  Expired,
  Expiring
}

export interface IExpiringQuestion {
  questionId: string;
  sectionId: string;
  sectionName: string;
  expirationDateType: ExpirationDateType;
}
